var blockquote_default = {
  "fontElementMap": "ZGDnn",
  "quote": "AWnH6"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
